module.exports = __webpack_public_path__ + "static/media/26 sq m.bb361e92.JPG";